<vitamui-common-object-editor [editObject]="editObject$ | async"></vitamui-common-object-editor>
